/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/camelcase */
import {
  ConvertObjectCamelToSnakeCaseV2,
  ConvertObjectCamelToSnakeCaseV3
} from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import {
  QueryParamsEntities,
  QueryParamsEntitiesV3
} from "@/domain/entities/MainApp";
import moment from "moment";
import { AddCargoRequestInteface } from "@/data/payload/contracts/CargoV2Request";
import {
  AddBagOrStt,
  DimensionPieces,
  FlightPlanForECargo
} from "./CargoApiRequest";
import { NGEN_BOOKING } from "@/app/infrastructures/misc/Constants";
import {
  BagOrStt,
  BagOrSttDetail,
  DimensionData,
  FormCargoV2
} from "@/domain/entities/CargoV2";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { getConfigDimensionDivider } from "@/app/ui/views/cargo-v2/modules/cargo-module";
import { flags } from "@/feature-flags";
import { capitalize } from "lodash";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import {
  normalizePayloadNumber,
  toNumber
} from "@/app/infrastructures/misc/common-library/NormalizePayloadNumber";

export class CargoV2ListRequest {
  page = 1;
  limit = 10;
  search = "";
  cargoType = "";
  cargoTypes = "";
  originCity = "";
  destinationCity = "";
  startDate = "";
  endDate = "";
  airportCode = "";
  partnerId = 0;
  status = "";
  hubIds = "";
  isTotalData = true;
  destinationAirport = "";
  type = "";
  countryCode = "";

  constructor(fields?: Partial<CargoV2ListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    const { cargoType, ...filter } = this;
    return new QueryParamsEntities(filter).queryString;
  }
}

export class CargoV2DisputeDownloadRequest {
  startDate = "";
  endDate = "";
  hubIds = "";
  cargoType = "";

  constructor(fields?: Partial<CargoV2DisputeDownloadRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CargoV2MinimumWeightSummaryApiRequest {
  startDate = "";
  endDate = "";
  hubIds = "";
  cargoType = "plane";

  constructor(fields?: Partial<CargoV2MinimumWeightSummaryApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CargoV2DownloadListRequest {
  startDate = "";
  endDate = "";
  hubIds = "";
  destinationCities = "";
  createdBy: number[] = [];
  cargoTypes = "";

  constructor(fields?: Partial<CargoV2DownloadListRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CargoV2DownloadListFailedRequest {
  search = "";
  cargoType = "";
  startDate = "";
  endDate = "";
  destinationCity = "";
  destinationAirport = "";
  hubIds = "";

  constructor(fields?: Partial<CargoV2DownloadListFailedRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export const CargoV2DetailActivityEnum = {
  IS_PRINT_LABEL: "is_print_label",
  IS_PRINT_AWB: "is_print_awb",
  IS_PRINT_PTI: "is_print_pti",
  IS_PRINT_SPTJ: "is_print_sptj",
  IS_PRINT_MANIFEST: "is_print_manifest",
  IS_INTERNAL: ""
} as const;

export type CargoV2DetailActivity = typeof CargoV2DetailActivityEnum[keyof typeof CargoV2DetailActivityEnum];

export interface GetDetailCargoV2ForPrintParams {
  id: string | number;
  activity?: CargoV2DetailActivity;
  isPrint: boolean;
}
export class CargoV2ListClientParentApiRequest {
  page = 1;
  limit = 10;
  search = "";
  transportType = "";
  hubId = 0;

  constructor(fields?: Partial<CargoV2ListClientParentApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class CargoV2CalculateRequest {
  calculateType = "";
  calculateRequest = {
    totalPieces: 0,
    length: 0,
    width: 0,
    height: 0,
    divider: 0,
    minVolumePerPiece: 0,
    isMinimumVolumePerPiece: false,
    volumeWeightReweigh: 0,
    chargeableWeightReweigh: 0,
    currentGrossWeight: 0,
    cargoType: "",
    currentChargeableWeight: 0
  };

  constructor(fields?: Partial<CargoV2CalculateRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    const currentGrossWeight = this.calculateRequest.currentGrossWeight;
    const totalPieces = this.calculateRequest.totalPieces;
    if (typeof currentGrossWeight === "string") {
      this.calculateRequest.currentGrossWeight = Number(
        (currentGrossWeight as string).replace(",", ".")
      );
    }
    if (typeof totalPieces === "string") {
      this.calculateRequest.totalPieces = Number(totalPieces);
    }
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}
export class CargoV2SearchFlightRequest {
  departureDate = moment().format("YYYY-MM-DD");
  originCityCode = "";
  destinationCityCode = "";
  actualTotalCargoGrossweight = 0;
  actualTotalCargoVolumeweight = 0;
  thresholdTime = 1440;
  commodityGroupCode = "";
  sort = "eta";
  dimensionArray: DimensionPieces[] = [];
  productCargo = "";
  shcCode = "";

  // display only
  originCityName = "";
  destinationCityName = "";
  actualTotalPiece = 0;
  isDangerousGoods = false;
  isQuarantine = false;
  signal?: AbortSignal;
  rtcId = 0;

  constructor(fields?: Partial<CargoV2SearchFlightRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    const dimensionArray = (this.dimensionArray ?? []).map((d) => ({
      length: toNumber(d.length),
      width: toNumber(d.width),
      height: toNumber(d.height),
      pieces: toNumber(d.pieces)
    }));

    const normalizeNumber = normalizePayloadNumber(
      new CargoV2SearchFlightRequest(),
      this
    );

    return ConvertObjectCamelToSnakeCaseV3({
      ...normalizeNumber,
      cargoPiece: normalizeNumber.actualTotalPiece,
      dimensionArray,
      signal: null
    });
  }
}
export class AddCargoRequest implements AddCargoRequestInteface {
  origin_airport_code: string;
  destination_airport_code: string;
  est_total_cargo_grossweigth: number;
  est_total_cargo_volumeweight: number;
  partner_name: string;
  partner_type: string;
  cargo_no: string;
  cargo_vehicle_no: string;
  actual_total_cargo_grossweigth: number;
  actual_total_cargo_volumeweight: number;
  route: string;
  total_stt: number;
  total_piece: number;
  cargo_commodity: string;
  product_cargo: string;
  cargo_type: string;
  origin_city_code: string;
  destination_city_code: string;
  departure_date: string;
  arrival_date: string;
  bag_or_stt: AddBagOrStt[];
  is_cargo_plane_manual: boolean | null;
  cargo_over_cutoff_limit: boolean | null;
  cargo_rtc_turn_auto: boolean | null;
  dimensions: DimensionPieces[];
  cargo_actual_piece: number;
  ngen_booking = {
    product_name: NGEN_BOOKING.PRODUCT_NAME,
    e_cargo_unique_id: NGEN_BOOKING.E_CARGO_UNIQUE_ID,
    awb_no: NGEN_BOOKING.AWB_NO,
    awb_prefix: NGEN_BOOKING.AWB_PREFIX,
    shc: "" as any,
    flight_plan_for_e_cargo: [] as FlightPlanForECargo[]
  };
  is_from_rtc: boolean;
  rtc_id: number;
  est_dimension?: DimensionData;
  actual_dimension?: DimensionData;
  nog?: string;
  rebookingId?: number;
  ngen_created_at?: string;
  hub_id?: number;
  hub_name?: number;
  hub_origin_city?: string;
  hub_district_code?: string;
  shc?: string;
  is_use_sabre?: boolean;
  sequential_flight?: number;
  total_flight?: number;
  photo_proof?: Array<string>;
  cargoTotalChargeableWeight?: number;
  cargoTotalCustomChargeableWeight?: number;
  cargoTotalEstimateChargeableWeight?: number;
  isNewCalculation?: boolean;
  isRecommended?: boolean;
  calculateType?: string;
  isValidAwbManual?: boolean;
  isCargoDimensionOn?: boolean;

  constructor(
    origin_airport_code: string,
    destination_airport_code: string,
    est_total_cargo_grossweigth: number,
    est_total_cargo_volumeweight: number,
    partner_name: string,
    partner_type: string,
    cargo_no: string,
    cargo_vehicle_no: string,
    actual_total_cargo_grossweigth: number,
    actual_total_cargo_volumeweight: number,
    route: string,
    total_stt: number,
    total_piece: number,
    cargo_commodity: string,
    product_cargo: string,
    cargo_type: string,
    origin_city_code: string,
    destination_city_code: string,
    departure_date: string,
    arrival_date: string,
    bag_or_stt: AddBagOrStt[],
    is_cargo_plane_manual: boolean | null,
    cargo_over_cutoff_limit: boolean | null,
    cargo_rtc_turn_auto: boolean | null,
    cargo_actual_piece: number,
    is_from_rtc: boolean,
    rtc_id: number,
    flight_plan_for_e_cargo?: FlightPlanForECargo[],
    dimensions?: DimensionPieces[],
    est_dimension?: DimensionData,
    actual_dimension?: DimensionData,
    nog?: string,
    rebookingId?: number,
    ngen_created_at?: string,
    shc?: string,
    is_use_sabre?: boolean,
    sequential_flight?: number,
    total_flight?: number,
    photo_proof?: Array<string>,
    cargoTotalChargeableWeight?: number,
    cargoTotalCustomChargeableWeight?: number,
    cargoTotalEstimateChargeableWeight?: number,
    isNewCalculation?: boolean,
    isRecommended?: boolean,
    calculateType?: string,
    isValidAwbManual?: boolean,
    isCargoDimensionOn?: boolean
  ) {
    this.origin_airport_code = origin_airport_code;
    this.destination_airport_code = destination_airport_code;
    this.est_total_cargo_grossweigth = est_total_cargo_grossweigth;
    this.est_total_cargo_volumeweight = est_total_cargo_volumeweight;
    this.partner_name = partner_name;
    this.partner_type = partner_type;
    this.cargo_no = cargo_no;
    this.cargo_vehicle_no = cargo_vehicle_no;
    this.actual_total_cargo_grossweigth = actual_total_cargo_grossweigth;
    this.actual_total_cargo_volumeweight = actual_total_cargo_volumeweight;
    this.route = route;
    this.total_stt = total_stt;
    this.total_piece = total_piece;
    this.cargo_commodity = cargo_commodity;
    this.product_cargo = product_cargo;
    this.cargo_type = cargo_type;
    this.origin_city_code = origin_city_code;
    this.destination_city_code = destination_city_code;
    this.departure_date = departure_date;
    this.arrival_date = arrival_date;
    this.bag_or_stt = bag_or_stt;
    this.is_cargo_plane_manual = is_cargo_plane_manual;
    this.cargo_over_cutoff_limit = cargo_over_cutoff_limit || false;
    this.cargo_rtc_turn_auto = cargo_rtc_turn_auto;
    this.ngen_booking.product_name = product_cargo;
    this.ngen_booking.flight_plan_for_e_cargo = flight_plan_for_e_cargo || [];
    this.ngen_booking.shc = shc;
    this.dimensions = dimensions || [];
    this.is_from_rtc = is_from_rtc;
    this.rtc_id = rtc_id;
    this.est_dimension = est_dimension;
    this.actual_dimension = actual_dimension;
    this.nog = nog;
    this.rebookingId = rebookingId;
    this.cargo_actual_piece = cargo_actual_piece;
    this.ngen_created_at = ngen_created_at;
    // this.hub_id = getHubData()?.hubId || 0;
    // this.hub_name = getHubData()?.hubName || "";
    // this.hub_origin_city = getHubData()?.originCity || "";
    // this.hub_district_code = getHubData()?.hubDistrictCode || "";
    this.is_use_sabre = is_use_sabre;
    this.sequential_flight = sequential_flight;
    this.total_flight = total_flight;
    this.photo_proof = photo_proof;
    this.cargoTotalChargeableWeight = cargoTotalChargeableWeight;
    this.cargoTotalCustomChargeableWeight = cargoTotalCustomChargeableWeight;
    this.cargoTotalEstimateChargeableWeight = cargoTotalEstimateChargeableWeight;
    this.isNewCalculation = isNewCalculation;
    this.isRecommended = isRecommended;
    this.calculateType = calculateType;
    this.isValidAwbManual = isValidAwbManual;
    this.isCargoDimensionOn = isCargoDimensionOn;
  }

  get hubId() {
    return getHubData()?.hubId || 0;
  }

  get hubName() {
    return getHubData()?.hubName || "";
  }

  get hubOriginCity() {
    return getHubData()?.originCity || "";
  }

  get hubDistrictCode() {
    return getHubData()?.hubDistrictCode || "";
  }

  get isUseSabre() {
    return (
      FlagsPermissionCargo.feature_flight_v2_enable.isEnabled() &&
      this.cargo_type === "plane" &&
      !this.is_cargo_plane_manual
    );
  }

  get isFromRTCSabre() {
    return this.is_from_rtc && this.isUseSabre;
  }

  get payloadPart1() {
    return {
      origin_airport_code: this.origin_airport_code,
      destination_airport_code: this.destination_airport_code,
      est_total_cargo_grossweigth: this.est_total_cargo_grossweigth,
      est_total_cargo_volumeweight: this.est_total_cargo_volumeweight,
      partner_name: this.partner_name,
      partner_type: this.partner_type,
      cargo_no: this.cargo_no,
      cargo_vehicle_no: this.cargo_vehicle_no,
      actual_total_cargo_grossweigth: this.actual_total_cargo_grossweigth,
      actual_total_cargo_volumeweight: this.actual_total_cargo_volumeweight,
      route: this.route,
      total_stt: this.total_stt,
      total_piece: this.total_piece,
      cargo_commodity: this.cargo_commodity,
      product_cargo: this.product_cargo
    };
  }

  get dimensionDivider() {
    return getConfigDimensionDivider(this.cargo_type);
  }

  get configIsMinimumVolumePerPiece(): boolean {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargo_type === "plane" && !this.is_cargo_plane_manual)
      return !!flag;
    return false;
  }

  get configMinimumVOlumePerPiece() {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();

    if (this.cargo_type === "plane" && !this.is_cargo_plane_manual) return flag;
    return 0;
  }

  toJSON(): string {
    let data: any = {
      ...this.payloadPart1,
      cargo_type: this.cargo_type,
      origin_city_code: this.origin_city_code,
      destination_city_code: this.destination_city_code,
      departure_date: this.departure_date,
      arrival_date: this.arrival_date,
      bag_or_stt: this.bag_or_stt,
      estimation_dimension: {
        cargo_est_length_dimension: this.est_dimension?.length,
        cargo_est_width_dimension: this.est_dimension?.width,
        cargo_est_height_dimension: this.est_dimension?.height
      },
      actual_dimension: {
        cargo_actual_length_dimension: this.actual_dimension?.length || 0,
        cargo_actual_width_dimension: this.actual_dimension?.width || 0,
        cargo_actual_height_dimension: this.actual_dimension?.height || 0
      },
      nog: this.nog,
      rebooking_id: this.rebookingId,
      cargo_actual_piece: this.cargo_actual_piece,
      ngen_created_at: this.ngen_created_at,
      hub_id: this.hubId,
      hub_name: this.hubName,
      hub_origin_city: this.hubOriginCity,
      hub_district_code: this.hubDistrictCode,
      is_from_rtc: this.is_from_rtc,
      rtc_id: this.rtc_id,
      cargo_over_cutoff_limit: this.cargo_over_cutoff_limit,
      cargo_rtc_turn_auto: this.cargo_rtc_turn_auto,
      is_from_rtc_sabre: this.isFromRTCSabre,
      is_use_sabre: this.isUseSabre,
      photo_proof: this.photo_proof,
      cargo_total_chargeable_weight: this.cargoTotalChargeableWeight,
      cargo_total_custom_chargeable_weight: this
        .cargoTotalCustomChargeableWeight,
      cargo_total_estimate_chargeable_weight: this
        .cargoTotalEstimateChargeableWeight,
      is_use_new_calculation: this.isNewCalculation,
      cargo_divider_dimension: this.dimensionDivider,
      is_recommended: this.isRecommended,
      calculate_type: this.calculateType,
      is_minimum_volume_per_piece: this.configIsMinimumVolumePerPiece,
      min_volume_per_piece: this.configMinimumVOlumePerPiece,
      is_cargo_dimension_on: this.rebookingId
        ? this.cargo_type !== "plane"
          ? false
          : this.isCargoDimensionOn
        : this.cargo_type !== "plane"
        ? false
        : this.is_cargo_plane_manual
        ? false
        : !flags.feature_hide_dimension_koli.isEnabled(),
      is_valid_awb_manual: this.isValidAwbManual
    };

    if (this.is_cargo_plane_manual !== null) {
      data = {
        ...data,
        is_cargo_plane_manual: this.is_cargo_plane_manual
      };
    }
    if (this.ngen_booking.flight_plan_for_e_cargo.length > 0) {
      data = {
        ...data,
        ngen_booking: this.ngen_booking,
        cargo_over_cutoff_limit: this.cargo_over_cutoff_limit,
        cargo_rtc_turn_auto: this.cargo_rtc_turn_auto
      };
    }
    if (this.isUseSabre) {
      data = {
        ...data,
        sequential_flight: this.sequential_flight,
        total_flight: this.total_flight
      };
    }
    const IS_PLANE_ONLY = flags.feature_dimension_plane_only.isEnabled();
    const isCargoPlane = this.cargo_type === "plane";
    if (IS_PLANE_ONLY && isCargoPlane) {
      data = {
        ...data,
        dimensions: this.dimensions
      };
    } else {
      if (!IS_PLANE_ONLY) {
        data = {
          dimensions: this.dimensions,
          ...data
        };
      }
    }
    return JSON.stringify(data);
  }
}

export class AwbValidationApiRequest {
  awbNo = "";
  originCity = "";
  destinationCity = "";
  constructor(fields?: Partial<AwbValidationApiRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CreateCargoV3ApiRequest extends FormCargoV2 {
  constructor(fields?: Partial<CreateCargoV3ApiRequest>) {
    super();

    if (!fields) return;

    const allowedKeys = Object.keys(this) as (keyof CreateCargoV3ApiRequest)[];

    for (const key of Object.keys(
      fields
    ) as (keyof CreateCargoV3ApiRequest)[]) {
      if (allowedKeys.includes(key)) {
        (this as any)[key] = fields[key];
      }
    }
  }

  get configIsMinimumVolumePerPiece(): boolean {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
    if (this.cargoType.value === "plane" && !this.isCargoPlaneManual)
      return !!flag;
    return false;
  }

  get configMinimumVOlumePerPiece() {
    const flag = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
    if (this.cargoType.value === "plane" && !this.isCargoPlaneManual)
      return flag;
    return 0;
  }

  toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV3({
      ...this.normalizeNumber,
      dimensions: (this.dimensions ?? []).map((item) => ({
        ...item,
        length: toNumber(item.length),
        width: toNumber(item.width),
        height: toNumber(item.height),
        pieces: toNumber(item.pieces),
        grossWeight: toNumber(item.grossWeight),
        volumeWeight: toNumber(item.volumeWeight)
      })),
      bagOrStt: this.bagOrStt.map((item) => ({
        bagNo: item.bagNo,
        sttNo: item.bagNo ? "" : item.sttNo
      })),
      isCargoPlaneManual: this.isValidAwbManual ? true : false,
      cargoType: this.cargoType.value,
      cargoCommodity: this.cargoCommodity.code,
      destinationCityCode: this.destinationCityCode.code,
      cargoDividerDimension: getConfigDimensionDivider(this.cargoType.value),
      originCityCode: LocationController.districtDetail.cityCode,
      partnerName: capitalize(
        AccountController.accountData.account_type_detail.company_name
      ),
      partnerType: AccountController.accountData.normalizedTypeUser,
      photoProof: this.photoProof
        .filter(Boolean)
        .filter((p) => typeof p === "string"),
      configIsMinimumVolumePerPiece: this.configIsMinimumVolumePerPiece,
      configMinimumVOlumePerPiece: this.configMinimumVOlumePerPiece,
      isMinimumVolumePerPiece: this.configIsMinimumVolumePerPiece,
      minVolumePerPiece: this.configMinimumVOlumePerPiece,
      hubId: getHubData()?.hubId,
      hubName: getHubData()?.hubName,
      hubDistrictCode: getHubData()?.hubDistrictCode,
      hubOriginCity: getHubData()?.originCity || "",
      driverName: this.driverSelected
    });
  }
}

export class CalculateVolumeRequestV2 {
  totalPieces = 0;
  length = 0;
  width = 0;
  divider = 0;
  height = 0;
  minVolumePerPiece = 0;
  isMinimumVolumePerPiece = true;
  volumeWeightReweigh = 0;
  chargeableWeightReweigh = 0;
  currentGrossWeight = 0;
  cargoType = "";
  totalStt = 0;
  maxDisputeWeight = 0;
  currentChargeableWeight = 0;

  constructor(fields?: Partial<CalculateVolumeRequestV2>) {
    Object.assign(this, fields);

    this.divider = getConfigDimensionDivider(this.cargoType);
  }
}

export class CalculateVolumeApiRequestV2 {
  calculateType = "";
  calculateRequest = new CalculateVolumeRequestV2();
  signal?: AbortSignal;

  constructor(fields?: Partial<CalculateVolumeApiRequestV2>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
        calculateRequest: new CalculateVolumeRequestV2(
          normalizePayloadNumber(
            new CalculateVolumeRequestV2(),
            this.calculateRequest
          )
        ),
        signal: undefined
      })
    );
  }
}

export class ScanApiRequest {
  bagOrStt = new BagOrStt();
  cargoProductType = "";
  cargoCommodity = "";
  cargoType = "";
  partnerId = 0;

  constructor(fields?: Partial<ScanApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV3({
      ...this,
      hub_id: getHubData()?.hubId || 0
    });
  }
}

export class RequestRtcList {
  page = 1;
  limit = 20;
  search = "";
  destinationCode = "";
  status = "";
  sortBy = "rtc_id";
  orderBy = "ASC";
  isTotalData = true;
  hubId = 0;
  transportType = "";
  clientParentIds: number[] = [];
  hasMinimumWeight = false;
  hasMinimumKoli = false;
  cotFilter = "";
  cotHours = 0;

  constructor(fields?: Partial<RequestRtcList>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV3(this));
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class RequestCheckEligibleRtcV2 {
  bagOrStt: BagOrSttDetail[] = [];

  constructor(fields?: Partial<RequestCheckEligibleRtcV2>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV3(this);
  }
}

export class DeleteRetryCargo {
  action = "delete";

  constructor(fields?: Partial<DeleteRetryCargo>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return ConvertObjectCamelToSnakeCaseV3(this);
  }
}

export class DownloadAWBRequest {
  id = 0 as number | string;
  awbNumber = "";
  constructor(fields?: Partial<DownloadAWBRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV3(this));
  }
}
